export default "__VITE_ASSET__969205bc__"